const headerToProps = props => ({
  title: { ...props.title.label, alignment: props.title.alignment },
  id: props.id,
  image: props.image,
});

export { headerToProps };
